import classNames from '@utils/classnames';
import React from 'react';

export interface IAvatarProps {
  url?: string | null;
  name: string;
  /** `sm` = 26px (sidebar), `md` = 32px (default). */
  size?: 'sm' | 'md';
  className?: string;
}

export const Avatar: React.FC<IAvatarProps> = (props) => {
  const { url, name, size = 'md', className } = props;

  const firstLetter = name.length > 0 ? name[0].toUpperCase() : 'T';
  const sizeClassName = size === 'sm' ? 'h-[26px] w-[26px] text-2xs' : 'h-8 w-8 text-xs';

  return url ? (
    <img
      className={classNames('shrink-0 rounded-full object-cover', sizeClassName, className)}
      src={url ?? '/static/fallback-avatar.svg'}
      alt={name}
      title={name}
    />
  ) : (
    <div
      className={classNames(
        'flex shrink-0 items-center justify-center rounded-full border border-brand-border bg-brand-subtle font-semibold text-brand-text',
        sizeClassName,
        className,
      )}
      title={name}
    >
      {firstLetter}
    </div>
  );
};
